// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'minus';

export const Component = () => <path d='M3.5 11.58h18v1.84h-18v-1.84Z' />;

export const viewBox = '0 0 25 25';
